<template>
	<div id="app">
		<!-- <div class="test" id="test" ref="test1">
			<div id="id1" class="red" ref="id11" @click="test1()"></div>
			<div id="id2" class="green" ref="id22" @click="jump()"></div>
			<div>123123</div> -->
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	import HelloWorld from './components/HelloWorld.vue'
	import anime from 'animejs/lib/anime.es.js'
	export default {
		name: 'app',
		components: {
			HelloWorld
		},
		data() {
			return {
				onOff: false,
				windowHeight: document.documentElement.clientHeight,
				page: 0
			}
		},
		created() {
			
		},
		mounted() {
			// window.addEventListener('mousewheel', this.test, false)
			if (this._isMobile()) {
				// alert("手机端");
				this.$router.replace('/index_mobile');
			} else {
				// alert("pc端");
				this.$router.replace('/index');
			}
		},
		methods: {
			_isMobile() {
			    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
			    return flag;
			},
			test(e) {
				var height = 0
				var direction = e.deltaY > 0 ? 'down' : 'up'
				if (direction == 'down') {
					this.page++
					console.log('down')
					this.$refs["id22"].scrollIntoView(true)
				} else {
					this.page--
					console.log('up')
					this.$refs["id11"].scrollIntoView(true)
				}
				setTimeout(function(){
					
				},400);
			},
			test1(){
				this.$refs["id22"].scrollIntoView(true)
			},
			jump(){
				this.$router.push('index');
			}
		},
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		/* margin-top: 60px; */
		/* height: 100%; */
	}
	*{
	    padding: 0;
	    margin: 0;
	  }

	html,
	body,
	#app {
		height: 100%;
	}

	/* .test {
		width: 100%;
		height: 100%;
	}

	.red {
		width: 100%;
		height: 100%;
		background-color: red;
	}

	.green {
		width: 100%;
		height: 100%;
		background-color: green;
	} */
</style>
